export default __webpack_public_path__ + "static/ben-9797d68bc70ea6c73290ccf6dc860f73.jpg";